import { Chip } from '@mui/joy';
import { X } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Color, Size, Variant } from 'theme/enums';

import { EMPTY_INVENTORY_FILTER } from './constants';
import { IInventoryFilterValue } from './types';
import { getInventoryShippingLocationLabel } from './utils';

interface IProps {
  value: IInventoryFilterValue;
  onChange: (next: IInventoryFilterValue) => void;
}

export const InventoryFilterChips = ({ value, onChange }: IProps) => {
  const { t } = useTranslation();

  const inStockOnly = value.onlyWithInventory;
  const hasLocation = !!value.shippingLocation;

  const onRemoveStockChip = () => onChange(EMPTY_INVENTORY_FILTER);
  const onRemoveLocationChip = () => onChange({ ...value, shippingLocation: null });

  if (!inStockOnly) {
    return null;
  }

  return (
    <>
      <Chip
        color={Color.NEUTRAL}
        variant={Variant.OUTLINED}
        size={Size.SM}
        endDecorator={<X size={16} onClick={onRemoveStockChip} style={{ cursor: 'pointer' }} />}
        onClick={onRemoveStockChip}
        sx={{ paddingBlock: '6px', borderRadius: 'sm' }}
      >
        {t('labelInStock')}
      </Chip>

      {hasLocation && (
        <Chip
          color={Color.NEUTRAL}
          variant={Variant.OUTLINED}
          size={Size.SM}
          endDecorator={
            <X size={16} onClick={onRemoveLocationChip} style={{ cursor: 'pointer' }} />
          }
          onClick={onRemoveLocationChip}
          sx={{ paddingBlock: '6px', borderRadius: 'sm' }}
        >
          {getInventoryShippingLocationLabel(value.shippingLocation)}
        </Chip>
      )}
    </>
  );
};
